import {AxiosResponse} from "axios";
import {ApiBase} from "./ApiBase";
import {IApiResult} from "./AxiosWealthManagementApi";
import {
    AdminRegion,
    CarouselCard,
    CreateRegionRequest, LoginContent,
    RegionHero,
    ServicePill,
    Stat
} from "../model/RegionLoginContent.model";

export class LoginContentAdminApi {
    public static getRegions(): Promise<AdminRegion[]> {
        return ApiBase.processGetUnwrapped(
            "/admin/login-content/regions",
            (response: AxiosResponse): AdminRegion[] => {
                return (response.data as AdminRegion[]);
            });
    }

    static createRegion(request: CreateRegionRequest): Promise<IApiResult<AdminRegion>> {
        return ApiBase.processPostWithResponseBody(
            "/admin/login-content/regions",
            request,
            (response: AxiosResponse) => {return response.data;}
        );
    }

    static deleteRegion(id: number) {
        return ApiBase.processDelete(`/admin/login-content/regions/${id}`);
    }

    static saveStats(regionId: number, stats: Stat[]) {
        return ApiBase.processPost(`/admin/login-content/regions/${regionId}/stats`, stats);
    }

    static savePills(regionId: number, pills: ServicePill[]) {
        return ApiBase.processPost(`/admin/login-content/regions/${regionId}/pills`, pills);
    }

    static saveCarouselCards(regionId: number, cards: CarouselCard[]) {
        return ApiBase.processPost(`/admin/login-content/regions/${regionId}/carousel`, cards);
    }

    static uploadCarouselImage(formData: FormData): Promise<IApiResult<number>> {
        return ApiBase.processPostWithResponseBody(
            "/admin/login-content/carousel-image",
            formData,
            (response: AxiosResponse): number => {
                return response.data;
            }
        );
    }

    static deleteCarouselImage(imageDocumentId: number) {
        return ApiBase.processDelete(`/admin/login-content/carousel-image/${imageDocumentId}`);
    }

    static saveCountries(regionId: number, countryCodes: string[]) {
        return ApiBase.processPost(`/admin/login-content/regions/${regionId}/countries`, countryCodes);
    }

    static saveRegionHero(regionId: number, regionHero: RegionHero) {
        return ApiBase.processPost(`/admin/login-content/regions/${regionId}/hero`, regionHero);
    }

    static publishRegion(regionId: number) {
        return ApiBase.processPost(`/admin/login-content/regions/${regionId}/publish`, {});
    }
}
